export const camelToKebab = (str = '') => str.replace(/[A-Z]/g, '-$&').toLowerCase()

export const kebabToCamel = (str = '') => str.replace(/-./g, (x) => x[1].toUpperCase())

export const toTitleCase = (str = '') =>
    str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase())

export const addSpaceToCamel = (str = '') => str?.replace(/([A-Z])(?=[a-z])/g, ' $1').trim() || ''
